<template>
    <div>
        <b-modal id="modal-delete" title="Delete">
            <p>Are you sure?</p>
<!--            <ul>
                <li>Deleting feedback will remove all references to it from posts.</li>
                <li>Posts that are in this feedback will not be affected.</li>
            </ul>-->
            <template #modal-footer="{ ok, cancel, hide }">
                <b-button variant="outline" @click="cancel()">Cancel</b-button>
                <b-button variant="danger" @click="deletefeedback(deleteId)">Delete</b-button>
            </template>
        </b-modal>


        <loading v-if="loading"></loading>
<!--        vragen aan chatgpt:
per feedback;
1. geef top 5 keywords
2. geef sentiment analyse op pos, neg, neutr
3. geef suggestie van posts => met title en desc


geef scope
1. Usability (User Experience & Interface)
What it Covers: This area focuses on how users interact with your product, including ease of use, navigation, accessibility, design aesthetics, and overall user satisfaction. It's about ensuring that users can accomplish their goals smoothly and intuitively.
Why It's Important: Good usability is crucial for initial adoption and ongoing engagement. If users find the product difficult or unpleasant to use, they're less likely to continue using it or recommend it to others.
2. Functionality (Features & Performance)
What it Covers: This encompasses the features of the product, how well they meet users' needs, and the product's reliability and performance. It includes the completeness of features, feature usability, reliability, performance, and integration capabilities.
Why It's Important: Users come to your product for its features and stay for the reliability. Ensuring that your product performs its intended functions efficiently and reliably is key to maintaining user trust and satisfaction.
3. Value (Problem Solving & Benefits)
What it Covers: This area focuses on the overall value your product provides to its users. It involves assessing whether the product effectively solves users' problems, fulfills their needs, and provides tangible benefits. It also considers the product's differentiation and competitive advantage.
Why It's Important: Ultimately, users choose and stick with products that offer them real value. Understanding how your product stands out in solving users' problems or providing unique benefits is crucial for long-term success and growth.

dan per load:
1. geef feedback summary in bullets
2. geef top 10 keywords negatief en pos
3. trends
-->
        <div v-else>
            <div class="mb-2 d-flex justify-content-between">
                <div>
                    <b-dropdown :variant="dropdownVariant(selectedSentiment)" size="sm">
                        <template #button-content>
                            <b-icon icon="heart-half" class="mr-1"></b-icon> Sentiment<span v-if="selectedSentiment">: {{selectedSentiment}}</span>
                        </template>
                        <div class="p-2">
                            <b-form-select v-model="selectedSentiment">
                                <option :value="null">All</option>
                                <option value="positive">Positive</option>
                                <option value="neutral">Neutral</option>
                                <option value="negative">Negative</option>
                            </b-form-select>

                            <b-button size="sm" variant="outline" @click="selectedSentiment = null" class="mt-2 btn-block">
                                Clear
                            </b-button>
                        </div>
                    </b-dropdown>
                    <b-dropdown :variant="dropdownVariant(selectedFocus)" size="sm">
                        <template #button-content>
                            <b-icon icon="bullseye" class="mr-1"></b-icon> Focus<span v-if="selectedFocus">: {{selectedFocus}}</span>
                        </template>
                        <div class="p-2">
                            <b-form-select v-model="selectedFocus">
                                <option :value="null">All</option>
                                <option value="usability">Usability</option>
                                <option value="functionality">Functionality</option>
                                <option value="value">Value</option>
                            </b-form-select>

                            <b-button size="sm" variant="outline" @click="selectedFocus = null" class="mt-2 btn-block">
                                Clear
                            </b-button>
                        </div>
                    </b-dropdown>
                    <b-dropdown :variant="dropdownVariant(selectedSource)" size="sm">
                        <template #button-content>
                            <b-icon icon="clipboard-data" class="mr-1"></b-icon> Source<span v-if="selectedSource">: {{selectedSource}}</span>
                        </template>
                        <div class="p-2">
                            <b-form-select v-model="selectedSource">
                                <option :value="null">All</option>
                                <template v-for="option in feedbackTypeOptions">
                                    <option :value="option.value">{{ option.text }}</option>
                                </template>
                            </b-form-select>

                            <b-button size="sm" variant="outline" @click="selectedSource = null" class="mt-2 btn-block">
                                Clear
                            </b-button>
                        </div>
                    </b-dropdown>

                    <b-dropdown :variant="dropdownVariant(selectedWidget)" size="sm">
                        <template #button-content>
                            <b-icon icon="columns-gap" class="mr-1"></b-icon> Widget<span v-if="selectedWidget">: {{selectedWidget}}</span>
                        </template>
                        <div class="p-2">
                            <b-form-select v-model="selectedWidget">
                                <option :value="null">All</option>
                                <template v-for="widget in widgetsOptions">
                                    <option :value="widget.id">{{ widget.name }}</option>
                                </template>
                            </b-form-select>
                            <b-button size="sm" variant="outline" @click="selectedWidget = null" class="mt-2 btn-block">Clear</b-button>
                        </div>
                    </b-dropdown>

                    <b-button @click="openDateRangeModal()" :variant="dropdownVariant(selectedDateRange.start)" size="sm">
                        <b-icon icon="clock-history" class="mr-1"></b-icon> Created
                        <span v-if="selectedDateRange.start">: {{ formatDateRange(selectedDateRange) }}</span>
                    </b-button>
                    <!-- Modal with temporary date range selection -->
                    <b-modal v-model="showDateRangeModal" title="Select Date Range" size="md" hide-footer>
                        <div class="p-2">
                            <b-form-group label="From">
                                <b-form-datepicker v-model="tempDateRange.start"></b-form-datepicker>
                            </b-form-group>
                            <b-form-group label="To">
                                <b-form-datepicker v-model="tempDateRange.end"></b-form-datepicker>
                            </b-form-group>
                            <b-button size="sm" variant="primary" @click="applyDateRange" class="mr-1">Apply</b-button>
                            <b-button size="sm" variant="outline-secondary" @click="clearDateRange">Clear</b-button>
                        </div>
                    </b-modal>



                    <b-dropdown :variant="dropdownVariant(selectedKeyword)" size="sm">
                        <template #button-content>
                            <b-icon icon="search" class="mr-1"></b-icon> Keyword<span v-if="selectedKeyword">: {{selectedKeyword}}</span>
                        </template>
                        <div class="p-2" style="min-width: 220px;">
                            <b-form-group>
                                <b-form-input v-model="keywordInput" placeholder="Enter keyword"></b-form-input>
                            </b-form-group>
                            <b-button size="sm" variant="primary" @click="selectedKeyword = keywordInput" class="mr-1">Apply</b-button>
                            <b-button size="sm" variant="outline" @click="selectedKeyword = null">Clear</b-button>
                        </div>
                    </b-dropdown>
                </div>
                <div>
                    <a class="btn btn-sm btn-outline" href="/admin/widgets/index"><b-icon icon="plus-circle" class="mr-1 text-primary"></b-icon> New widget</a>
                </div>

            </div>

            <div class="row">
                <div class="col-md-4 order-1">
                    <b-card class="mb-2" no-body>
                        <b-card-header class="bg-transparent font-weight-bold border-0">Sentiment</b-card-header>
                        <b-card-body>
                            <div id="chart" v-b-tooltip :title="'Positive: ' + overall_sentiment.positive*100 + '%' + ' Negative: ' + overall_sentiment.negative*100 + '%' + ' Neutral: ' + overall_sentiment.neutral*100 + '%' ">
                                <b-progress :max="100" show-value>
                                    <b-progress-bar :value="overall_sentiment.positive * 100" variant="success"></b-progress-bar>
                                    <b-progress-bar :value="overall_sentiment.neutral * 100" variant="warning"></b-progress-bar>
                                    <b-progress-bar :value="overall_sentiment.negative * 100" variant="danger"></b-progress-bar>
                                </b-progress>
<!--                                <vc-donut :sections="sentimentGraph" :size="50" unit="%" background="grey">-->
<!--                                    <div class="w-100 text-center">-->
<!--                                        <p v-if="overall_sentiment.sentiment === 'positive'" class="h2 mx-auto"><span class="text-success"><b-icon icon="emoji-heart-eyes"></b-icon></span></p>-->
<!--                                        <p v-else-if="overall_sentiment.sentiment === 'negative'" class="mb-0 d-flex align-items-center"><span class="text-danger"><b-icon icon="emoji-frown"></b-icon></span></p>-->
<!--                                        <p v-else-if="overall_sentiment.sentiment === 'neutral'" class="mb-0 d-flex align-items-center"><span class="text-warning"><b-icon icon="emoji-neutral"></b-icon></span></p>-->
<!--                                    </div>-->
<!--                                </vc-donut>-->
                            </div>
                        </b-card-body>
                    </b-card>
                    <b-card class="mb-2" no-body>
                        <b-card-header class="bg-transparent font-weight-bold border-0">Feedback Summary</b-card-header>
                        <b-card-body>
                            <template v-if="summary">
                                <div class="mb-2" v-html="summary"></div>
                                <b-button variant="outline" @click="summary = null" size="sm">Reset</b-button>
                            </template>
                            <loading v-else-if="loadingSummary"></loading>
                            <template v-else>
                                <b-button variant="primary" @click="getSummary"><i class="bi bi-stars"></i> Summarize</b-button>
                            </template>
                        </b-card-body>
                    </b-card>
                    <b-card class="mb-2 card-sidebar" no-body>
                        <b-card-header class="bg-transparent font-weight-bold border-0">Top Keywords</b-card-header>
                        <b-card-body>
                            <template v-for="keyword in top_keywords">
                                <b-card class="mb-2" body-class="py-2 px-2">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p class="mb-0">
                                            <span class="small">{{keyword.keyword}}</span>
                                            <small><span class="badge badge-outline text-muted badge-sm">{{keyword.percentage}}%</span></small>
                                        </p>

                                        <p v-if="keyword.sentiment === 'positive'" class="mb-0 d-flex align-items-center"><span class="badge badge-success mr-2"><b-icon icon="emoji-heart-eyes"></b-icon></span> <span class="small text-muted">{{keyword.total}}</span></p>
                                        <p v-else-if="keyword.sentiment === 'negative'" class="mb-0 d-flex align-items-center"><span class="badge badge-danger mr-2"><b-icon icon="emoji-frown"></b-icon></span> <span class="small text-muted">{{keyword.total}}</span></p>
                                        <p v-else-if="keyword.sentiment === 'neutral'" class="mb-0 d-flex align-items-center"><span class="badge badge-warning mr-2"><b-icon icon="emoji-neutral"></b-icon></span> <span class="small text-muted">{{keyword.total}}</span></p>
                                    </div>
                                </b-card>
                            </template>
                        </b-card-body>
                    </b-card>
                    <b-card class="mb-2 card-sidebar" no-body>
                        <b-card-header class="bg-transparent font-weight-bold border-0">Suggested Posts</b-card-header>
                        <b-card-body>
                            <template v-for="post in top_suggested_posts">
                                <b-card class="mb-2" body-class="py-2 px-2">
                                    <div class="d-flex align-items-center justify-content-between w-100">
                                        <div class="mr-2" style="flex-grow: 1; overflow: hidden;max-width: 80%;">
                                            <p class="mb-0 text-truncate" v-b-tooltip :title="post.description">
                                                <small><span class="badge badge-outline text-muted badge-sm">{{post.total}}</span></small>
                                                <span class="small ml-1">{{post.title}}</span>
                                            </p>
                                        </div>
                                        <p class="mb-0">
                                            <a title="Create post" v-b-tooltip :href="getCreatePostLink(post.title, post.description)" class="btn btn-sm btn-outline">
                                                <b-icon-plus-circle></b-icon-plus-circle>
                                            </a>
                                        </p>
                                    </div>



                                </b-card>
                            </template>
                        </b-card-body>
                    </b-card>
                </div>
                <div class="col-md-8 order-0">
                    <template v-for="feedback in feedback">
                        <b-card class="mb-2">
                            <div class="d-flex justify-content-between w-100">
                                <div class=" w-100">
                                    <div class="d-flex justify-content-between w-100">
                                        <div class="m-0 d-flex align-items-center">
                                            <span v-if="feedbackTypes[feedback.type]" v-b-tooltip :title="feedbackTypes[feedback.type].title" class="d-flex justify-content-center align-items-center mr-2" :style="{ backgroundColor: feedbackTypes[feedback.type].bgColor, borderRadius: '50%', fontSize: '10px', height: '20px', width: '20px' }">
                                                <b-icon :icon="feedbackTypes[feedback.type].icon" :style="{ color: feedbackTypes[feedback.type].iconColor }"></b-icon>
                                            </span>

                                            <span class="font-weight-bold mr-2">{{getDisplayedSourceName(feedback)}}</span>
                                            <span class="text-muted small" v-b-tooltip :title="feedback.created_at | readableDate">{{feedback.created_at_human_diff}}</span>
                                        </div>
                                        <b-dropdown variant="outline" size="sm" class="m-md-2" no-caret>
                                            <template #button-content>
                                                <b-icon icon="three-dots" class="text-muted"></b-icon>
                                            </template>
                                            <b-dropdown-item @click="openEdit(feedback.id)">
                                                <b-icon icon="pencil-square"></b-icon> Edit
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="askDelete(feedback.id)">
                                                <b-icon icon="trash"></b-icon> Delete
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </div>
                                    <p class="my-3" v-html="feedback.feedback"></p>
                                    <div class="d-flex align-items-center">
                                        <span v-if="feedback.analysis_status==='todo'" v-b-tooltip title="Feedback analysis planned."><b-icon icon="clock"></b-icon></span>
                                        <span v-else-if="feedback.analysis_status==='skipped'" v-b-tooltip title="Feedback analysis skipped, probably because the feedback is too short to analyze." class="text-muted"><b-icon icon="skip-end"></b-icon></span>
                                        <span v-else-if="feedback.analysis_status==='no_credits'" v-b-tooltip title="Feedback analysis skipped, because you don't have enough credits. Go to your account page to upgrade." class="text-warning"><b-icon icon="coin"></b-icon></span>
                                        <span v-else-if="feedback.analysis_status==='failed'" v-b-tooltip title="Feedback analysis failed."><b-icon icon="exclamation-triangle-fill" class="text-warning"></b-icon></span>
                                        <template v-else>
                                            <div v-b-tooltip :title="'Positive: ' + feedback.positive_sentiment*100 + '%' + ' Negative: ' + feedback.negative_sentiment*100 + '%' + ' Neutral: ' + feedback.neutral_sentiment*100 + '%' ">
                                                <p v-if="feedback.sentiment === 'positive'" class="mb-0 d-flex align-items-center"><span class="badge badge-success mr-2"><b-icon icon="emoji-heart-eyes"></b-icon></span> <span class="small text-muted">Positive</span></p>
                                                <p v-else-if="feedback.sentiment === 'negative'" class="mb-0 d-flex align-items-center"><span class="badge badge-danger mr-2"><b-icon icon="emoji-frown"></b-icon></span> <span class="small text-muted">Negative</span></p>
                                                <p v-else-if="feedback.sentiment === 'neutral'" class="mb-0 d-flex align-items-center"><span class="badge badge-warning mr-2"><b-icon icon="emoji-neutral"></b-icon></span> <span class="small text-muted">Neutral</span></p>
                                            </div>

                                            <span class="mx-2 text-muted">&middot;</span>

                                            <b-icon :icon="getFocusIcon(feedback.usability_focus)" class="mx-2 text-primary mr-2"></b-icon> <span class="small text-muted" v-b-tooltip :title="'Usability Focus: ' + feedback.usability_focus*100 + '%'">Usability</span>
                                            <b-icon :icon="getFocusIcon(feedback.functionality_focus)" class="mx-2 text-primary mr-2"></b-icon> <span class="small text-muted" v-b-tooltip :title="'Functionality Focus: ' + feedback.functionality_focus*100 + '%'">Functionality</span>
                                            <b-icon :icon="getFocusIcon(feedback.value_focus)" class="mx-2 text-primary"></b-icon> <span class="small text-muted" v-b-tooltip :title="'Value Focus: ' + feedback.value_focus*100 + '%'">Value</span>
                                        </template>
                                        <span class="mx-2 text-muted">&middot;</span>
                                        <p class="m-0" v-if="feedback.user"><a :href="feedback.user.profile_url" class="text-muted"><img class="profile" :src="feedback.user.avatar_small_url" style=" height: 20px; width: 20px;" /> <span class="small">{{feedback.user.name}}</span></a></p>
                                    </div>
                                </div>
                            </div>

                            <div v-if="editId === feedback.id">
                                <hr/>{{editId}}
                                <validation-observer ref="observer" v-slot="{ passes }">
                                    <form @submit.stop.prevent="passes(editfeedback)" class="row">
                                        <div class="col-4">
                                        <validation-provider name="feedback" rules="min:2|required" v-slot="{ errors }">
                                            <b-form-input v-model="feedbackInput"></b-form-input>
                                            <span class="validation">{{ errors[0] }}</span>
                                        </validation-provider>
                                        </div>

                                        <div class="col-4">
                                        <a class="btn btn-outline mt-2 mr-2" @click='editId = 0'>Cancel</a>
                                        <button type="submit" class="btn btn-success  mt-2">Save</button>
                                        </div>
                                    </form>
                                </validation-observer>
                            </div>
                        </b-card>
                    </template>
                    <template v-if="feedback.length === 0">
                        <p class="mt-4">No feedback found yet.</p>

                        <div class="alert alert-info mt-3" role="alert">
                        This feature allows you to capture and organize user feedback efficiently. Watch the video below for a step-by-step guide on how to use it effectively.
                        </div>

                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe src="https://www.loom.com/embed/6da17956f0974057b8183588ff9c92f4?sid=bd57d4ab-dd50-4e97-bb7d-5d52b7416afc" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                        </div>

<!--                        <b-embed-->
<!--                            type="video"-->
<!--                            src="/img/feedback_widget.mp4"-->
<!--                            allowfullscreen-->
<!--                            autoplay-->
<!--                        ></b-embed>-->
                    </template>


                    <b-button v-if="!isNewFormOpen" class="mt-4 btn-outline" @click='isNewFormOpen = true'>
                        <b-icon icon="plus-circle" class="mr-1 text-primary"></b-icon>
                        Add feedback
                    </b-button>
                    <div v-else class="mt-4">
                        <validation-observer ref="observer" v-slot="{ passes }">
                            <form @submit.stop.prevent="passes(createfeedback)">
                                <b-form-group label="Feedback" label-for="feedback-input">
                                    <validation-provider name="feedbackInput" rules="min:2|required" v-slot="{ errors }">
                                        <!-- Use b-form-textarea instead of b-form-input for multi-line text input -->
                                        <b-form-textarea
                                            id="feedback-input"
                                            v-model="feedbackInput"
                                            placeholder="Enter feedback..."
                                            rows="2"
                                        max-rows="6"
                                        ></b-form-textarea>
                                        <span class="validation">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group label="Type" label-for="feedback-type-select">
                                    <b-form-select id="feedback-type-select" v-model="selectedFeedbackType" class="mt-2" :options="feedbackTypeOptions" placeholder="Select feedback type"></b-form-select>
                                </b-form-group>

                                <b-form-group label="User" label-for="user-autocomplete">
                                    <UserAutocomplete id="user-autocomplete" v-model="selectedUserId" @input="onUserSelect" />
                                </b-form-group>

                                <div class="form-actions">
                                    <a class="btn btn-outline-primary mt-2 mr-2" @click='isNewFormOpen = false'>Cancel</a>
                                    <button type="submit" class="btn btn-success mt-2">Create</button>
                                </div>
                            </form>

                        </validation-observer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'
import UserAutocomplete from "./UserAutocomplete";
import Loading
    from "./Loading";


export default {
    name: "feedback",
    mixins: [NotificationPop],
    components: {
        UserAutocomplete,
        Loading
    },

    data() {
        return {
            feedbackTypes: {
                'feedback_widget': { bgColor: '#93C5FD', icon: 'chat-left', title: 'Widget', iconColor: '#ffffff' },
                'manual': { bgColor: '#FFC107', icon: 'hand-index', title: 'Manual', iconColor: '#000000' },
                'call': { bgColor: '#007bff', icon: 'telephone', title: 'Call', iconColor: '#ffffff' },
                'email': { bgColor: '#6c757d', icon: 'envelope', title: 'Email', iconColor: '#ffffff' },
                'ticket': { bgColor: '#28a745', icon: 'ticket', title: 'Ticket', iconColor: '#ffffff' },
                'x': { bgColor: '#1da1f2', icon: 'x', title: 'X', iconColor: '#ffffff' },
                'facebook': { bgColor: '#1877f2', icon: 'facebook', title: 'Facebook', iconColor: '#ffffff' },
                'linkedin': { bgColor: '#0a66c2', icon: 'linkedin', title: 'LinkedIn', iconColor: '#ffffff' },
                'whatsapp': { bgColor: '#25d366', icon: 'whatsapp', title: 'WhatsApp', iconColor: '#ffffff' },
                'youtube': { bgColor: '#ff0000', icon: 'youtube', title: 'YouTube', iconColor: '#ffffff' },
                'instagram': { bgColor: '#c32aa3', icon: 'instagram', title: 'Instagram', iconColor: '#ffffff' },
                'tiktok': { bgColor: '#010101', icon: 'tiktok', title: 'TikTok', iconColor: '#ffffff' },
                'reddit': { bgColor: '#ff4500', icon: 'reddit', title: 'Reddit', iconColor: '#ffffff' },
                'twitch': { bgColor: '#9146ff', icon: 'twitch', title: 'Twitch', iconColor: '#ffffff' },
                'discord': { bgColor: '#5865f2', icon: 'discord', title: 'Discord', iconColor: '#ffffff' },
                'slack': { bgColor: '#4a154b', icon: 'slack', title: 'Slack', iconColor: '#ffffff' },
                'telegram': { bgColor: '#0088cc', icon: 'telegram', title: 'Telegram', iconColor: '#ffffff' },
                'live_chat': { bgColor: '#66757f', icon: 'chat-dots', title: 'Live Chat', iconColor: '#ffffff' }, // Assuming a default gray background
                'intercom': { bgColor: '#1f2d3d', icon: 'intercom', title: 'Intercom', iconColor: '#ffffff' }, // Assuming a default dark background
                'capterra': { bgColor: '#ff9900', icon: 'star-fill', title: 'Capterra', iconColor: '#ffffff' }, // Capterra's brand color
                'trustpilot': { bgColor: '#00b67a', icon: 'stars', title: 'Trustpilot', iconColor: '#ffffff' }, // Trustpilot's brand color
                'appsumo': { bgColor: '#ff1f2c', icon: 'bag-fill', title: 'AppSumo', iconColor: '#ffffff' }, // AppSumo's brand color
                'g2': { bgColor: '#f26522', icon: 'graph-up', title: 'G2', iconColor: '#ffffff' }, // G2's brand color
                'yelp': { bgColor: '#af0606', icon: 'star-fill', title: 'Yelp', iconColor: '#ffffff' }, // Yelp's brand color
                'google_reviews': { bgColor: '#4285f4', icon: 'geo-alt-fill', title: 'Google Reviews', iconColor: '#ffffff' }, // Google's brand color
                'getapp': { bgColor: '#22b573', icon: 'app-indicator', title: 'GetApp', iconColor: '#ffffff' },
                'trustradius': { bgColor: '#00a1f1', icon: 'compass', title: 'TrustRadius', iconColor: '#ffffff' },
                'software_advice': { bgColor: '#ff9900', icon: 'laptop', title: 'Software Advice', iconColor: '#ffffff' },
            },

            selectedFeedbackType: 'manual',

            selectedWidget: null,
            selectedKeyword: null,
            keywordInput: '',
            widgetsOptions: [],
            showDateRangeModal: false,
            selectedDateRange: { start: null, end: null },
            tempDateRange: { start: null, end: null },// Temporary holding object for dates while in the modal

            loading: true,
            loadingSummary: false,
            summary: null,
            feedback: [],
            top_keywords: [],
            top_suggested_posts: [],
            overall_sentiment: null,
            isNewFormOpen: false,
            isEditFormOpen: false,
            toggleHex: false,
            editId: null,
            deleteId: 0,
            feedbackInput: '',
            color: null,
            selectedUserId: null,
            sentimentGraph: [],

            selectedSentiment: null,
            selectedFocus: null,
            selectedSource: null,
        }
    },

    async created() {
        this.fetchFeedback()

        // Get all widgets
        this.$http.get('/http_api/widgets')
            .then(({data}) => {
                this.widgetsOptions = data.data.map(widget => ({
                    id: widget.id,
                    name: widget.name
                }));
                console.log(this.widgetsOptions);
            })
            .catch(error => {
                this.loading = false;
                this.popNotification('Something went wrong on our side. Could not load widgets. Please try again or contact ruben@productlift.dev', 'danger');
            });
    },
    watch: {
        selectedSentiment() {
            this.fetchFeedback();
        },
        selectedFocus() {
            this.fetchFeedback();
        },
        selectedSource() {
            this.fetchFeedback();
        },
        selectedWidget() {
            this.fetchFeedback();
        },
        selectedDateRange: {
            handler() {
                this.fetchFeedback();
            },
            deep: true // This is necessary because selectedDateRange is an object
        },
        selectedKeyword() {
            this.fetchFeedback();
        },
    },

    computed: {
        feedbackTypeOptions() {
            return Object.entries(this.feedbackTypes).map(([value, { title }]) => ({
                value, // The key in the feedbackTypes object
                text: title // The title property of each feedback type
            }));
        }
    },

    methods: {
        fetchFeedback() {
            this.loading = true;
            const params = {
                sentiment: this.selectedSentiment,
                focus: this.selectedFocus,
                source: this.selectedSource,
                widget: this.selectedWidget,
                created_from: this.selectedDateRange.start,
                created_to: this.selectedDateRange.end,
                keyword: this.selectedKeyword,
            };

            this.$http.get('/http_api/feedback/fetch', { params })
                .then(({data}) => {
                    this.loading = false;
                    this.feedback = data.feedback;
                    this.top_keywords = data.top_keywords;
                    this.top_suggested_posts = data.top_suggested_posts;
                    this.overall_sentiment = data.overall_sentiment;
                    this.sentimentGraph = [
                        { label: 'Positive', value: this.overall_sentiment.positive*100, color: '#86EFAC' },
                        { label: 'Neutral', value: this.overall_sentiment.neutral*100, color: '#FDBA74' },
                        { label: 'Negative', value: this.overall_sentiment.negative*100, color: '#FCA5A5' },
                    ];
                })
                .catch(error => {
                    this.loading = false;
                    this.popNotification('Something went wrong on our side. Could not load feedback. Please try again or contact ruben@productlift.dev', 'danger');
                });
        },
        getSummary() {
            this.loadingSummary = true;
            const params = {
                sentiment: this.selectedSentiment,
                focus: this.selectedFocus,
                source: this.selectedSource,
                widget: this.selectedWidget,
                created_from: this.selectedDateRange.start,
                created_to: this.selectedDateRange.end,
                keyword: this.selectedKeyword,
            };

            this.$http.get('/http_api/feedback/summarize', { params })
                .then(({data}) => {
                    this.loadingSummary = false;

                    if(data.status === 'no_credits') {
                        this.popNotification('Please upgrade your AI credits. Go to your account page.', 'info');
                        return;
                    }

                    this.summary = data.summary;
                })
                .catch(error => {
                    this.loading = false;
                    this.popNotification('Something went wrong on our side. Could not load summary. Please try again or contact ruben@productlift.dev', 'danger');
                });
        },
        openDateRangeModal() {
            // Copy selectedDateRange to tempDateRange when opening the modal
            this.tempDateRange = { ...this.selectedDateRange };
            this.showDateRangeModal = true;
        },

        applyDateRange() {
            // Apply the tempDateRange back to selectedDateRange
            this.selectedDateRange = { ...this.tempDateRange };
            this.showDateRangeModal = false; // Close the modal
            this.fetchFeedback(); // Fetch feedback with new filters
        },

        clearDateRange() {
            this.tempDateRange = { start: null, end: null }; // Clear temp range
            // Optionally reset selectedDateRange here or in a separate clear action
            this.showDateRangeModal = false; // Close the modal
            this.fetchFeedback(); // Optionally fetch feedback if needed
        },
        getCreatePostLink(input_title, input_description) {
            const title = encodeURIComponent(input_title);
            const description = encodeURIComponent(input_description);
            return `/admin/posts/bulk?title=${title}&description=${description}`;
        },
        getFocusIcon(score) {
            if (score >= 0.67) {
                return 'circle-fill'; // High focus
            } else if (score >= 0.33) {
                return 'circle-half'; // Medium focus
            } else {
                return 'circle'; // Low focus
            }
        },
        getDisplayedSourceName(feedbackItem) {
            if(feedbackItem.type === 'feedback_widget') {
                return feedbackItem.source_name; // Return original title for 'feedback_widget'
            } else if(this.feedbackTypes[feedbackItem.type]) {
                return this.feedbackTypes[feedbackItem.type].title; // Return the title from feedbackTypes
            } else {
                return feedbackItem.source_name; // Fallback to original title if type is not in feedbackTypes
            }
        },
        onUserSelect(id) {
            // Assuming `option` contains the selected item structure { text, value }
            this.selectedUserId = id;
        },

        /**
         * Create new feedback
         */
        createfeedback: function () {
            this.$http.post('/http_api/feedback',{
                feedback: this.feedbackInput,
                type: this.selectedFeedbackType,
                user_id: this.selectedUserId
            })
                .then(({data}) => {
                    // add to list
                    this.feedback.push(data.data);
                    // clear form and toggle
                    this.feedbackInput = ''
                    this.isNewFormOpen = false
                    this.popNotification('Created', 'success')
                })
                .catch(error => {
                    // handle authentication and validation errors here
                    console.log(error.response.data.errors)
                    this.popNotification('Could not create', 'danger')
                })
        },

        /**
         * Display edit form inside item
         * @param id feedback id
         */
        openEdit: function (id) {
            let index = this.feedback.findIndex(feedback => feedback.id === id)

            this.editId = id
            this.feedbackInput = this.feedback[index].feedback
            this.selectedFeedbackType = this.feedback[index].type
        },

        /**
         * Save edit form
         */
        editfeedback: function () {
            let index = this.feedback.findIndex(feedback => feedback.id === this.editId)

            this.$http.patch('/http_api/feedback/' + this.editId,{
                feedback: this.feedbackInput,
            })
                .then(({response}) => {
                    this.popNotification('Updated', 'success')
                    this.feedback[index].feedback = this.feedbackInput

                    this.editId = 0 // close form
                    this.feedbackInput = ''
                })
                .catch(error => {
                    // handle authentication and validation errors here
                    console.log(error.response.data.errors)
                    this.popNotification('Could not update', 'danger')
                })
        },

        /**
         * Show modal to ask for deletion
         * @param id
         */
        askDelete: function (id) {
            this.$bvModal.show('modal-delete')
            this.deleteId = id
        },

        /**
         * After confirm, delete the feedback
         * @param id feedback id
         */
        deletefeedback: function (id) {
            // Close the modal
            this.$bvModal.hide('modal-delete')

            let index = this.feedback.findIndex(feedback => feedback.id === id)

            this.$http.delete('/http_api/feedback/' + id)
                .then(({response}) => {
                    this.popNotification('Deleted', 'success')
                })
                .catch(error => {
                    // handle authentication and validation errors here
                    console.log(error.response.data.errors)
                    this.popNotification('Could not delete', 'danger')
                })

            this.feedback.splice(index, 1)
        },

        dropdownVariant(field) {
            return field !== null ? 'warning' : 'outline';
        },

        formatDateRange(selectedDateRange) {
            return selectedDateRange.start + ' ' + selectedDateRange.end;
        },

    }
}
</script>